import { State } from '../stateDefinition';

export const getSwipe = ({ swipe }: State) => swipe;
